import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/app/homepage/components/ScrollToTop.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/ellanmobility/src/styles/tailwind.css");
